/**
 * Tabs the manifest declares but this build does not draw yet. Each names what
 * builds it, so a declared tab is a plan a person can read, never an error
 * and never a blank viewport (KET-6498 build-time corrections).
 */
export const COMING_NEXT: Record<string, string> = {
  skeletons: "Skeleton editing arrives with the marketing skeleton endpoints (MK-10).",
  snippets: "Snippet editing, with cross-team usage on every row, arrives with MK-11.",
  doctrine: "Doctrine comes in the next Qualume module build. Its CVCE endpoints already exist.",
  ctas: "CTAs come in the next Qualume module build. Their CVCE endpoints already exist.",
  formats: "Format length budgets come in the next Qualume module build.",
  runs: "Marketing runs from the customer-voice vault come in the next Qualume module build.",
  versions: "Versions, rollback and Publish arrive with the marketing publish scope (MK-13).",
  media: "The Media Navigator arrives here in the next Qualume release (R2).",
  settings: "Review delegation and criteria weights arrive in a later Qualume release.",
  command_line: "The screen-to-command map arrives with the qualume CLI.",
};

export function ComingNext({ tabKey }: { tabKey: string }) {
  const line = COMING_NEXT[tabKey] ?? "This tab comes in a later Qualume module build.";
  return (
    <div className="flex flex-col gap-1 py-6">
      <p className="text-base font-semibold text-ks-ink">Coming next</p>
      <p className="text-sm text-ks-ink">{line}</p>
    </div>
  );
}
